import React from "react";
import { AllImages } from "../../Assets/Images/AllImages";
import user from "../../Common/JsonFiles/simran.json";
import "./Certifications.scss";
const Certifications = () => {
  const openCertification = (item) => {
    window.open(item?.url);
  };
  return (
    <div className="certification-main-container">
      <div className="d-flex a-i-c flex-wrap">
        {user?.certifications?.map((item, id) => (
          <img  key={id.toString()}
            className="certification-img"
            onClick={() => openCertification(item)}
            src={AllImages[item?.img]}
            alt=""
          />
        ))}
      </div>
    </div>
  );
};

export default Certifications;
